import { Directive, EventEmitter, HostBinding, HostListener, Inject, Injector, Input, Output } from '@angular/core';
import * as R from 'ramda';

import { ButtonComponent } from '../../components';
import { valueAccessorFactory } from '../../helpers';
import { PreventDefault } from '../../util';
import { BaseInputDirective } from '../base-input.directive';
import { formControlFactory } from '../form-control.provider';

@Directive({
  selector: '[pcsButtonToggle]',
  providers: [
    valueAccessorFactory(ButtonToggleDirective),
    formControlFactory(ButtonToggleDirective)
  ]
})
export class ButtonToggleDirective extends BaseInputDirective {
  @Input() value = false;
  // predefined ON and OFF values
  @Input() onValue: any = true;
  @Input() offValue: any = false;
  @Input()
  set disabled(value) {
    this._disabled = value;
    this.button.disabled = value;
  }

  @Output() clicked = new EventEmitter();

  @HostBinding('class.btn-toggle')
  private readonly rootClasses = true;

  @HostBinding('class.btn-toggle-on')
  private get buttonOn() {
    return R.equals(this.value, this.onValue);
  }

  @HostBinding('class.btn-toggle-off')
  private get buttonOff() {
    return R.equals(this.value, this.offValue);
  }

  constructor(
    private injector: Injector,
    @Inject(ButtonComponent) private button: ButtonComponent
  ) {
    super();
  }

  @HostListener('click')
  onToggle() {
    if (!this.button.disabled) {
      this.value = R.equals(this.value, this.onValue) ? this.offValue : this.onValue;
      this.propagateChange(this.value);
      this.clicked.emit(this.value);
    }
  }

  @PreventDefault()
  @HostListener('blur', ['$event'])
  onBlur(event) {
    if (!this.button.disabled) {
      this.propagateTouched(event);
    }
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  setDisabledState(isDisabled: boolean): void {
    this._disabled = isDisabled;
    this.button.disabled = isDisabled;
  }
}
